<template>
  <div
    :class="[{ 'mobile-setting': mobileSetting }]">
    <div
      v-if="stores && stores.length && !mobileSetting"
      class="mb-3 w-xs-100"
      style="width: 300px">
      <select
        v-model="storeId"
        class="form-control"
        @change="onSelectStore">
        <option
          v-for="store in stores"
          :key="store.id"
          :value="store.id">{{ store.name }}</option>
      </select>
    </div>

    <!-- Storefont Status Setting -->
    <h3 class="font-20">{{ $lang.messages.online_storefront_status }}</h3>
    <div class="row mb-2">
      <div class="col-8">
        <p class="font-16 text-grey">{{ $lang.messages.online_storefront_open_store }}</p>
      </div>
      <div class="col-4 text-right align-self-center">
        <div class="form-group">
          <span class="switch switch-sm">
            <input
              type="checkbox"
              v-model="params.storefront_status"
              @change="onToggleStorefrontStatus"
              id="switch-status"
              class="switch"/>
            <label for="switch-status"></label>
          </span>
        </div>
      </div>
    </div>
    <!-- Storefont Status Setting -->

    <div v-if="d2c_type !== 0">
      <div class="row mb-2">
        <div class="col-8">
          <p class="font-16 text-grey">{{ $lang.messages.sobat_store }}</p>
        </div>
        <div class="col-4 text-right align-self-center">
          <div class="form-group">
            <span class="switch switch-sm">
              <input
                type="checkbox"
                v-model="params.sobat"
                @change="onToggleSobat"
                id="switch-sobat"
                class="switch"/>
              <label for="switch-sobat"></label>
            </span>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-8">
          <p class="font-16 text-grey">Sobat Catalog Category</p>
          <div
            v-if="sobat_categories && sobat_categories.length && !mobileSetting"
            class="mb-3 w-xs-100"
            style="width: 300px">
            <select
              v-model="sobatCategoryId"
              class="form-control">
              <option
                v-for="c in sobat_categories"
                :key="c.id"
                :value="c.id">{{ c.name }}</option>
            </select>
          </div>
        </div>
      </div>

    </div>

    <!-- Storefont Information Setting -->
    <h3 class="font-20 mb-1">{{ $lang.messages.online_storefront_store_information }}</h3>

    <div class="row mb-4">
      <div class="col-md-9">
        <p class="font-16 text-grey mb-1">
          {{ $lang.messages.online_storefront_image }}
          <span style="color: rgb(255, 0, 0);">*</span>
        </p>

        <div>
          <vue-cropper
            style="max-width: 512px"
            v-if="storefrontImage"
            ref="cropper"
            :aspectRatio="1/1"
            :initialAspectRatio="1/1"
            :autoCropArea="1"
            :src="storefrontImage"/>
          <img
            v-else
            id="storefront-image"
            style="max-width: 512px"
            :src="(storeFront && storeFront.store_image_representation) ? storeFront.resized_image_representation : ''"
            width="100%"
            class="d-block"
            alt="image thumb"/>
          <button
            for="storefront-image-uploader"
            type="button"
            style="max-width: 512px"
            class="btn btn-primary btn-block upload-img-merge-btn">
            {{ $lang.messages.upload_image }}
            <input
              ref="imageUploader"
              name="storefront-image-uploader"
              id="storefront-image-uploader"
              type="file"
              @change="loadImagePreview"
              @click="resetImageUploader"
              class="btn upload-img"
              accept="image/*"/>
          </button>

          <div class="row mt-3" v-if="storefrontImage">
            <i class="fas fa-sync-alt fa-2x ml-2 mr-3"  style="cursor: pointer;" @click.prevent="reset"/>
            <i class="fas fa-search-plus fa-2x mr-3 ml-2"  style="cursor: pointer;" @click.prevent="zoom(0.2)"/>
            <i class="fas fa-search-minus fa-2x mr-3 ml-2"  style="cursor: pointer;" @click.prevent="zoom(-0.2)"/>
            <i class="fas fa-undo fa-2x mr-3 ml-2"  style="cursor: pointer;" @click.prevent="rotate(-90)"/>
            <i class="fas fa-undo fa-2x fa-flip-horizontal mr-3 ml-2"  style="cursor: pointer;" @click.prevent="rotate(90)"/>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-6">
        <p class="font-16 text-grey mb-1">
          {{ $lang.messages.whats_app_number }}
          <span style="color: rgb(255, 0, 0);">*</span>
        </p>
        <p>{{ $lang.messages.whats_app_desc }}</p>

        <div class="input-group mb-1">
          <div class="input-group-prepend">
            <label class="input-group-text">+62</label>
          </div>
          <input
            v-validate="'required|numeric|min:7|notStartWithZero'"
            name="phone_number"
            type="text"
            v-model="params.phone_number"
            :placeholder="$lang.messages.mobile_number"
            :class="['input form-control pristine untouched', { 'is-danger': errors.has('phone_number') }]"
            class="input form-control pristine untouched">
        </div>
        <p
          v-if="errors.has('phone_number')"
          class="font-14 help is-danger">
          <span v-if="params.phone_number.startsWith('0', 0)">*{{ $lang.messages.please_enter_handphone_number }}</span>
          <span v-else-if="!(/^-?\d+$/.test(params.phone_number))">*{{ $lang.messages.please_enter_handphone_number }}</span>
          <span v-else>*{{ $lang.messages.please_enter_10_digits_hand_phone }}</span>
        </p>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-6">
        <p class="font-16 text-grey mb-0">
          {{ $lang.messages.online_storefront_domain }}
          <span style="color: rgb(255, 0, 0);">*</span>
        </p>
        <p>{{ $lang.messages.online_storefront_domain_desc }}</p>

        <div class="form-group form-inline mb-2">
          <label>konekto.us/</label>
          <p
            class="ml-2 form-control mb-0"
            style="background-color: #e9ecef;opacity: 1;"
            v-if="storeFront && storeFront.slug">{{ storeFront.slug }}</p>

          <input
            v-else
            v-validate="'required'"
            name="slug"
            type="text"
            class="ml-2 form-control"
            @input="onCheckSlugAvailable"
            :placeholder="$lang.messages.online_storefront_domain_holder"
            :class="[
              'ml-2 form-control',
              { 'is-valid': params.slug && isSlugAvailable && (storeFront && !storeFront.slug), 'is-danger': errors.has('slug') || !isSlugAvailable }
            ]"
            v-model="params.slug" />
        </div>

        <p
          v-if="errors.has('slug')"
          class="font-14 help mb-0 is-danger">
          *{{ $lang.messages.please_enter_domain_link }}
        </p>
        <p
          v-if="!isSlugAvailable && params.slug"
          class="font-14 help is-danger">
          *{{ $lang.messages.online_storefront_domain_error }}
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-4">
        <p class="font-16 text-grey mb-0">
          {{ $lang.messages.working_hours_information }}
          <span style="color: rgb(255, 0, 0);">*</span>
        </p>
        <textarea
          name="working_hours_information"
          v-validate="'required'"
          style="height: 160px"
          class="form-control"
          :class="['form-control', { 'is-danger': errors.has('working_hours_information') }]"
          v-model="params.working_hours_information"
          :placeholder="$lang.messages.working_hours_holder"/>

        <p
          v-if="errors.has('working_hours_information')"
          class="font-14 help is-danger">
          *{{ $lang.messages.required_to_fill }}
        </p>
      </div>

      <div class="col-md-6 mb-4">
        <p class="font-16 text-grey mb-0">
          {{ $lang.messages.delivery_information }}
          <span style="color: rgb(255, 0, 0);">*</span>
        </p>
        <textarea
          name="delivery_information"
          v-validate="'required'"
          v-model="params.delivery_information"
          style="height: 160px"
          :placeholder="$lang.messages.delivery_holder"
          :class="['form-control', { 'is-danger': errors.has('delivery_information') }]" />

        <p
          v-if="errors.has('delivery_information')"
          class="font-14 help is-danger">
          *{{ $lang.messages.required_to_fill }}
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-4">
        <p class="font-16 text-grey mb-0">
          {{ $lang.messages.payment_note }}
        </p>
        <textarea
          name="payment_information"
          class="form-control"
          v-model="params.payment_information"
          :placeholder="$lang.messages.payment_holder"
          style="height: 160px" />
      </div>

      <div class="col-md-6 mb-4">
        <p class="font-16 text-grey mb-0">{{ $lang.messages.other_note }}</p>
        <textarea
          v-model="params.other_note"
          class="form-control"
          :placeholder="$lang.messages.other_note_holder"
          style="height: 160px" />
      </div>
    </div>
    <!-- Storefont Information Setting -->

    <!-- Product catalog -->
    <div class="mb-4">
      <h3 class="font-20 mb-1">{{ $lang.messages.product_catalog }}</h3>
      <h6 class="font-16 mb-1 mt-4">{{ $lang.messages.recommended_items }} ({{recommendedItems.length}}/10)</h6>
      <div v-if="recommendedItems.length" class="">
        <draggable
            tag="div"
            direction="horizontal"
            :list="recommendedItems"
            class="row m-1 card-deck flex-row flex-nowrap"
            style="overflow-x: auto;"
            @change="changeRecommendItemPosition"
            handle=".draggable-card">
            <template v-for="(promotion, index) in recommendedItems">
              <div class="card border-0 ml-1" style="max-width: 5.5rem; padding-left: 0; flex: 0 0 auto; ">
                <div class="card-header bg-transparent" style="padding: 0px 1px 0px 2px">
                  <div class="mt-3 bg-transparent page-header">
                    <div class="float-left" style="padding-top: 5px">
                      <h6 >{{promotion.priority+1}}</h6>
                    </div>
                    <div class="float-right" style="padding-right: 2px">
                      <img src='/images/move.svg'>
                    </div>
                  </div>
                </div>
                <img style="object-fit: cover; width: auto; height: 90px; padding: 3px 3px 3px 3px; cursor: move;" class="draggable-card card-img-top" :src="promotion.item.representation_image_thumbnail">
                <div class="draggable-card card-body" style="padding-left: 0; padding-top: 0; padding-right: 0; padding-bottom: 0; cursor: move">
                  <h6 class="card-text">{{ promotion.item.name }}</h6>
                </div>
                <div class="card-footer bg-transparent border-success" style="text-align: center; padding: 1px 1px 1px 1px">
                  <a @click="onRemoveItemToRecommend(promotion)" href="javascript: void(0);" style="color: #d55f54; font-size: 0.85rem">
                    {{ $lang.messages.remove.toUpperCase() }}
                  </a>
                </div>
              </div>
            </template>
        </draggable>
      </div>
      <div v-else>
        <p class="font-15 mb-3 mt-1">
          {{$lang.messages.you_are_not_add_recommend_items}}
        </p>
      </div>

      <form @submit.prevent="onSearchStoreItems">
      <div class="input-group">
        <input
          v-model="items.searchKey"
          type="text"
          class="form-control"
          :placeholder="$lang.messages.search_product_name_or_sku"
          aria-label="Search Product Name or SKU"
          aria-describedby="basic-addon2">
        <div class="input-group-append">
          <button
            class="btn btn-primary"
            id="basic-addon2"
            style="height: 40px; min-width: 48px"
            @click="onSearchStoreItems">
            <i class="fas fa-search font-16"></i>
          </button>
        </div>
      </div>
      </form>

      <div
        class="table-responsive mt-3"
        v-if="items.data && items.data.results && items.data.results.length">
        <table
          id="table-product-catalog"
          v-if="mobileSetting"
          class="table table-striped table-style-1 table-bordered">
          <tbody>
            <tr
              v-for="item in items.data.results"
              :key="item.id">
              <td>
                <p>{{ item.item_variant_combination ? `${item.item.name} (${item.item_variant_combination.value})` : item.item.name }}</p>
                <p class="text-grey">{{ ((item.item_variant_combination && item.item_variant_combination.sku) ? item.item_variant_combination.sku : item.item.sku) || '' }}</p>
              </td>
              <td>
                <button
                  v-if="item.store_profile_item_id"
                  @click="onRemoveItemOutOfStorefront(item)"
                  class="btn btn-link">{{ $lang.messages.remove_product }}</button>
                <button
                  v-else
                  @click="onAddItemToStoreFront(item)"
                  class="btn btn-link">{{ $lang.messages.add_product }}</button>
              </td>
              <td>
                <button
                    v-if="item.recommended"
                    @click="onAddItemToRecommend(item)"
                    class="btn btn-link"
                    >{{ $lang.messages.remove }}
                </button>
                <button
                    v-else
                    @click="onAddItemToRecommend(item)"
                    class="btn btn-link"
                    >{{ $lang.messages.recommend }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <table
          v-else
          class="table table-striped table-style-1 table-bordered">
          <thead>
            <tr>
              <th class="text-center">{{ $lang.messages.product_name }}</th>
              <th class="text-center">{{ $lang.messages.sku }}</th>
              <th class="text-center">{{ $lang.messages.add_or_remove_product }}</th>
              <th class="text-center">{{ $lang.messages.recommended_product }}</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="item in items.data.results"
              :key="item.id">
              <td>{{ item.item_variant_combination ? `${item.item.name} (${item.item_variant_combination.value})` : item.item.name }}</td>
              <td class="text-center">
                {{ ((item.item_variant_combination && item.item_variant_combination.sku) ? item.item_variant_combination.sku : item.item.sku) || '-' }}
              </td>
              <td class="text-center">
                <button
                  v-if="item.store_profile_item_id"
                  @click="onRemoveItemOutOfStorefront(item)"
                  class="btn btn-outline-primary"
                  style="min-width: 168px">{{ $lang.messages.remove_product }}</button>
                <button
                  v-else
                  @click="onAddItemToStoreFront(item)"
                  class="btn btn-primary"
                  style="min-width: 168px">{{ $lang.messages.add_product }}</button>
              </td>
              <td class="text-center">
                  <button
                    v-if="item.recommended"
                    @click="onAddItemToRecommend(item)"
                    class="btn btn-outline-primary"
                    style="min-width: 168px">{{ $lang.messages.remove }}
                  </button>
                  <button
                    v-else
                    @click="onAddItemToRecommend(item)"
                    class="btn btn-primary"
                    style="min-width: 168px">{{ $lang.messages.recommend }}
                  </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="page-bottom-pagination text-right">
          <pagination
            ref="itemPagination"
            :page="items.page"
            :itemsCount="items.data.count"
            :itemsPerPage="items.perPage"
            @page-change="onPageChange($event)"
            @items-per-page-change="onPerPageChange($event)" />
        </div>
      </div>
      <p
        v-else
        class="text-center mt-3">{{ $lang.messages.no_product_found }}</p>
    </div>
    <!-- Product catalog -->

    <!-- Promotion links setting -->
    <h3 class="font-20 mb-1">{{ $lang.messages.promotion_links }}</h3>
    <p class="font-16 text-grey">{{ $lang.messages.promotion_link_desc }}</p>

    <div v-if="promos.length">
      <draggable
        tag="div"
        :list="promos"
        @change="changePromotionLinkPosition"
        handle=".card-tagger">
        <div
          v-for="(promotion, index) in promos"
          :key="promotion.uuid"
          class="card">
          <div class="card-tagger">
            <span>...</span>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <div>
                  <input
                    v-model="promotion.title"
                    :name="`promtion-title-${promotion.uuid}`"
                    v-validate="'required'"
                    class="card-title form-control-plaintext mb-0"
                    style="padding: 0"
                    type="text"
                    :placeholder="$lang.messages.enter_title">
                  <p
                    v-if="errors.has(`promtion-title-${promotion.uuid}`)"
                    class="font-14 help is-danger mb-0">
                    *{{ $lang.messages.required_to_fill }}
                  </p>
                </div>

                <div>
                  <input
                    v-model="promotion.url"
                    v-validate="{required: true, url: {require_protocol: true }}"
                    :name="`promtion-url-${promotion.uuid}`"
                    style="padding: 0"
                    class="font-14 form-control-plaintext mb-0"
                    type="text"
                    placeholder="http://url">
                  <p
                    v-if="errors.has(`promtion-url-${promotion.uuid}`)"
                    class="font-14 mb-0 help is-danger">
                    *{{ $lang.messages.link_is_not_valid }}
                  </p>
                </div>
              </div>
              <div class="col-3 text-right">
                <div class="form-group">
                  <span class="switch switch-sm">
                    <input
                      type="checkbox"
                      :id="`switch-promotion-${promotion.uuid}`"
                      v-model="promotion.enable"
                      class="switch"/>
                    <label :for="`switch-promotion-${promotion.uuid}`"></label>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <button
              @click="onRemovePromo(promotion, index)"
              class="btn bg-white">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </draggable>
    </div>
    <p class="text-center" v-else>{{ $lang.messages.no_promotion_link_available }}</p>

    <div class="text-center">
      <button
        @click="clickAddNewPromo"
        class="btn btn-primary">{{ $lang.messages.add_new_link }}</button>
    </div>
    <!-- Promotion links setting -->

    <div class="mt-5 text-right">
      <button
        @click="updateStorefrontConfirm"
        class="btn btn-primary">{{ $lang.messages.save }}</button>
    </div>

    <alert
      ref="storefrontPreviewModal"
      @rightButtonEvent="onUpdateStorefront($event)"
      :leftButton="$lang.messages.cancel"
      :rightButton="$lang.messages.continue"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="storefront-preview-modal"
      :title="$lang.messages.online_storefront">
      <p class="font-18 text-center">{{ $lang.messages.online_storefront_domain_confirm }}</p>
    </alert>

    <alert
      :title="$lang.messages.online_storefront"
      ref="storefrontImageInvalid"
      rightButton=""
      leftButton=""
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="storefront-image-validator-alert">
      <p class="font-18 text-center">{{ $lang.messages.image_ratio_1_3_validator }}</p>
    </alert>

    <alert
      :title="$lang.messages.online_storefront"
      ref="recommendItemAlert"
      rightButton=""
      leftButton=""
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="recommend-item-alert">
      <p class="font-18 text-center">{{ $lang.messages.you_can_only_add_up_to_10_product }}</p>
    </alert>

    <alert
      @rightButtonEvent="gotoEditItem()"
      :title="$lang.messages.online_storefront"
      ref="noPriceItem"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="no-price-item-modal"
    />

    <alert
      ref="productBeforeUpdateStorePreviewModal"
      @rightButtonEvent="updateStorefrontConfirm($event)"
      @leftButtonEvent="forceUpdateAsProductEmpty = false"
      @click-overlay="forceUpdateAsProductEmpty = false"
      :leftButton="$lang.messages.cancel"
      :rightButton="$lang.messages.continue"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="product-before-update-store-preview-modal"
      :title="$lang.messages.product_catalog">
      <p class="font-18 text-center">{{ $lang.messages.product_catalog_empty_alert }}</p>
    </alert>

    <alert
      ref="productBeforeRemoveLastItemPreviewModal"
      @rightButtonEvent="onRemoveItemOutOfStorefront(productCatalogTarget)"
      @leftButtonEvent="forceUpdateAsProductEmpty = false"
      @click-overlay="forceUpdateAsProductEmpty = false"
      :leftButton="$lang.messages.cancel"
      :rightButton="$lang.messages.continue"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="product-before-remove-last-item-preview-modal"
      :title="$lang.messages.product_catalog">
      <p class="font-18 text-center">{{ $lang.messages.product_catalog_remove_last_alert }}</p>
    </alert>
    <Alert
      @rightButtonEvent="goToPaymentSettings($event)"
      @leftButtonEvent="params.storefront_status = false"
      :title="$lang.messages.online_storefront"
      ref="setPayment"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="set-payment-modal"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import Alert from '@/components/Alert'
import draggable from "vuedraggable"
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  data() {
    return {
      cropImg: '',
      stores: [],
      sobat_categories: [],
      storeId: 0,
      sobatCategoryId: null,
      storeFront: null,
      storefrontImage: null,
      params: {
        storefront_status: false,
        sobat: false,
        sobat_catalog_price: null,
        age_restriction: null,
        sobat_catalog_description: null,
        phone_number: '',
        slug: '',
        delivery_information: '',
        working_hours_information: '',
        payment_information: '',
        other_note: '',
        force_disable_delivery_option: null
      },
      promos: [],
      promosRawData: [],
      items: {
        page: 1,
        searchKey: '',
        perPage: 10,
        data: null
      },
      dummyPromos: {
        uuid: '',
        title: '',
        url: '',
        enable: true,
        priority: 0
      },
      isSlugAvailable: true,
      isImageValid: true,
      debounce: null,
      noPriceItemID: null,
      forceUpdateAsProductEmpty: false,
      productCatalogTarget: null,
      recommendedItems: []
    }
  },

  props: {
    mobileSetting: {
      type: Boolean
    }
  },

  components: {
    Pagination,
    Alert,
    draggable,
    VueCropper,
  },

  computed: {
    queryStoreId() {
      return this.$route && this.$route.query && this.$route.query.store_id
    },

    queryLanguage() {
      return this.$route && this.$route.query && this.$route.query.lang
    },
    d2c_type(){
      return parseInt(localStorage.getItem('d2c_type') || 0)
    }
  },

  methods: {
    // Vue cropper
    reset() {
      this.$refs.cropper.reset();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },

    // ========================= Storefront Profile ====================== //
    getStores() {
      return this.$api
        .getAPI({ _action: '/store/get_back_office?status=ACTIVE' })
        .then(res => {
          this.stores = res.list;
          return res
        })
        .catch(e => {
          throw e
        })
    },
    getSobatCategories() {
      return this.$api
        .getAPI({ _action: '/sobat/category' })
        .then(res => {
          this.sobat_categories = res.results;
          return res
        })
        .catch(e => {
        })
    },

    getStorefontByStoreId(storeId) {
      return this.$api
        .getAPI({ _action: `/storefront/profile?store=${storeId}` })
        .then(res => {
          this.storeFront = res && res.results && res.results[0]
          this.initStorefontParamsRequest()
          // setup data related storefront
          if(this.storeFront && this.storeFront.sobat_categories && this.storeFront.sobat_categories.length){
            this.sobatCategoryId = this.storeFront.sobat_categories[0]
          }else{
            this.sobatCategoryId = null
          }

          if (this.storeFront && this.storeFront.promos) {
            this.promos = this.storeFront.promos.map(item => {
              item.uuid = this.uuidv4()
              return item
            })

            // Set recommended slug
            if(!!!this.storeFront.slug && this.params.slug === undefined || this.params.slug == ""){
              this.params.slug = this.storeFront.recommended_slug
            }
          }

          // clear validate
          this.$validator.reset()
        })
        .catch(e => { throw e })
    },

    async createOrGetStorefront() {
      await this.getStorefontByStoreId(this.storeId)
      if (this.storeFront) return

      await this.onCreateStorefront()
    },

    initStorefontParamsRequest() {
      if (this.storeFront) {
        Object.keys(this.params).forEach(key => {
          this.params[key] = this.storeFront[key]
        })
      } else {
        this.storeFront = null
        this.sobatCategoryId = null
        this.params = {
          storefront_status: false,
          sobat: false,
          sobat_catalog_description: null,
          phone_number: '',
          sobat_catalog_price: null,
          age_restriction: null,
          slug: '',
          delivery_information: '',
          working_hours_information: '',
          payment_information: '',
          other_note: ''
        }
      }
    },

    async onCreateStorefront() {
      let that = this
      return this.$api
        .postAPI({
          _action: '/storefront/profile',
          _body: that.getStorefrontParamsRequest(),
        })
        .then(res => {
          that.storeFront = res

          return res
         })
        .catch(e => { throw e })
    },

    async onUpdateStorefront() {
      let that = this

      // update related data first
      await this.onUploadImage()

      if (!this.isImageValid) {
        this.$refs.storefrontPreviewModal && this.$refs.storefrontPreviewModal.close()
        this.$refs.productBeforeUpdateStorePreviewModal && this.$refs.productBeforeUpdateStorePreviewModal.close()
        this.$refs.noPriceItem && this.$refs.noPriceItem.close()
        this.$refs.productBeforeRemoveLastItemPreviewModal && this.$refs.productBeforeRemoveLastItemPreviewModal.close()
        $('#storefront-image-validator-alert').modal('show')
        return
      }

      await this.addOrUpdatePromotions()

      return this.$api
        .putAPI({
          _action: `/storefront/profile/${this.storeFront.id}`,
          _body: that.getStorefrontParamsRequest(),
        })
        .then(res => {
          // reset all validator flag
          that.isSlugAvailable = true

          // close modal
          that.$refs.storefrontPreviewModal && that.$refs.storefrontPreviewModal.close()

          // update storefront data
          if (!res.message) {
            that.storeFront = res
          }

          if (res.message) {
            // show message
            this.$notify({
              group: 'foo',
              text: res.message,
              type: 'success'
            })
          } else {
            // show message
            this.$notify({
              group: 'foo',
              text: this.$lang.messages.successful_saved,
              type: 'success'
            })
          }

          this.$emit('needConfirm', false)

          return res
        })
        .catch(e => {
          if (e.status === 406) {
            that.$notify({
              group: 'foo',
              text: e.data.message,
              type: 'error'
            })
          }
          if (e.status === 409) {
            console.log(e)
            that.$notify({
              group: 'foo',
              text: e.data.message,
              type: 'error'
            })
          }

          // reset status
          that.params.storefront_status = that.storeFront.storefront_status
          that.params.sobat = that.storeFront.sobat
        })
        .finally(() => {
          that.$refs.productBeforeUpdateStorePreviewModal.close()
          that.forceUpdateAsProductEmpty = false
        })
    },

    onToggleStorefrontStatus() {
      const that = this
      const storeProfile = this.getStorefrontProfileInit()
      storeProfile.storefront_status = this.params.storefront_status

      return this.$api
        .putAPI({
          _action: `/storefront/profile/${this.storeFront.id}`,
          _body: storeProfile,
        })
        .then(res => {
          // reset all validator flag
          that.isSlugAvailable = true

          // update storefront status
          that.storeFront.storefront_status = res.storefront_status

          if (res.message) {
            // show message
            that.$notify({
              group: 'foo',
              text: res.message,
              type: 'success'
            })
          } else {
            // show message
            that.$notify({
              group: 'foo',
              text: that.params.storefront_status ? that.$lang.messages.store_open_now : that.$lang.messages.store_close_now,
              type: 'success'
            })
          }

          this.$emit('needConfirm', false)

          return res
        })
        .catch(e => {
          if (e.status === 406) {
            that.$notify({
              group: 'foo',
              text: e.data.message,
              type: 'error'
            })

            // reset status
            that.params.storefront_status = that.storeFront.storefront_status
          }
          if (e.status === 409) {
            that.$refs.setPayment.message = e.data.message;
            $('#set-payment-modal').modal('show');
          }
        })
    },

    onToggleSobat() {
      const that = this
      const storeProfile = this.getStorefrontProfileInit()
      storeProfile.sobat = this.params.sobat

      return this.$api
        .putAPI({
          _action: `/storefront/profile/${this.storeFront.id}`,
          _body: storeProfile,
        })
        .then(res => {
          that.storeFront.sobat = res.sobat
          if(!that.storeFront.sobat){
            that.sobatCategoryId = null
          }
          return res
        })
        .catch(e => {
          if (e.status === 406) {
            that.$notify({
              group: 'foo',
              text: e.data.message,
              type: 'error'
            })
            that.params.sobat = that.storeFront.sobat
          }
        })
    },

    updateStorefrontConfirm() {
      let that = this
      this.$validator.validateAll().then(async result => {
        if (result) {
          // check product catalog is empty?
          if (!!that.storeFront && !!that.storeFront.product_item_count && that.storeFront.product_item_count <= 0 && !that.forceUpdateAsProductEmpty) {
            $('#product-before-update-store-preview-modal').modal('show')
            that.forceUpdateAsProductEmpty = true
            return
          }

          if (that.storeFront && that.storeFront.slug) {
            await that.onUpdateStorefront()
          } else {
            $('#storefront-preview-modal').modal('show')
          }
        }
      })
    },

    getStorefrontParamsRequest() {
      return {
        ...this.params,
        slug: this.params.slug ? this.params.slug : null,
        store_id: this.storeId,
        categories: this.sobatCategoryId ? [this.sobatCategoryId] : null
      }
    },

    getStorefrontProfileInit() {
      const storeProfile = {}
      Object.keys(this.params).forEach(key => {
        storeProfile[key] = this.storeFront[key]
      })
      storeProfile.store_id = this.storeId

      return storeProfile
    },


    goToPaymentSettings(e){
      this.params.storefront_status = false;
      this.params.sobat = false;
      this.$refs.setPayment.close();
      $('#settings-tab').click()
      $('.nav-tabs a[href="#tab' + 3 + '"]').click();
      this.$emit('goToPayment')
    },


    async onSelectStore() {
      this.resetLocalState()
      await this.createOrGetStorefront()
      this.setupStoreFrontRelatedData()
    },

    resetImageUploader(e) {
      this.$refs.imageUploader.value = ''
    },

    // Store image
    loadImagePreview(e) {
      const files = e.target.files
      let that = this
      if (files && files[0]) {
        let reader = new FileReader()
        reader.onload = e => {
          // validate ratio
          var image = new Image()
          //Set the Base64 string return from FileReader as source.
          image.src = e.target.result
          //Validate the File Height and Width.
          image.onload = function () {
            // that.storefrontImage = files[0]
            that.storefrontImage = e.target.result
            $('#storefront-image').attr('src', e.target.result)
            that.$refs.cropper.replace(e.target.result);
            return true
          }
        }
        reader.readAsDataURL(files[0])
      }
    },

    onUploadImage() {
      let that = this
      if(!this.$refs.cropper){
        return
      }
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      if (this.storefrontImage) {
        return this.$api
          .uploadImageAPIAsPatch({
            _action: `/storefront/profile/${this.storeFront.id}/upload`,
            _file: that.cropImg
          })
          .then(res => {
            this.storefrontImage = null
            return res
          })
          .catch(e => { throw e })
      }
    },

    // ========================= Store Product Items ======================= //
    onGetStoreItems(bodyRequest = this.getStoreItemParams()) {
      return this.$api
        .getAPI({
          _action: `/storefront/${this.storeFront.id}/available-item`,
          _body: bodyRequest
        })
        .then(res => {
          this.items.data = res

          return res
        })
        .catch(e => { throw e })
    },

    getStoreRecommendItems() {
      return this.$api
        .getAPI({
          _action: `/storefront/items?store_profile=${this.storeFront.id}&recommended=true&ordering=priority,updated_at&offset=0&limit=10`,
        })
        .then(res => {
          this.recommendedItems = res.results
          for(let i=0; i<this.recommendedItems.length; i++){
            this.recommendedItems[i].priority = i
          }
        })
        .catch(e => { throw e })
    },

    onPageChange(page) {
      this.items.page = page
      this.onGetStoreItems()
    },

    onPerPageChange(perPage) {
      this.items.page = 1
      this.items.perPage = perPage
      this.onGetStoreItems()
    },

    getStoreItemParams() {
      return {
        offset: (this.items.page - 1) * this.items.perPage,
        limit: this.items.perPage,
        q: this.items.searchKey
      }
    },

    onSearchStoreItems() {
      const bodyRequest = {
        offset: 0,
        limit: 10,
        q: this.items.searchKey
      }

      this.onGetStoreItems(bodyRequest)
    },

    onAddItemToStoreFront(item) {
      const bodyRequest = {
        item_id: item.item.id,
        store_profile: this.storeFront.id
      }
      if (item.item_variant_combination) bodyRequest.item_variant_combination_id = item.item_variant_combination.id
      this.$api
        .postAPI({
          _action: '/storefront/items',
          _body: bodyRequest
        })
        .then(res => {
          item.store_profile_item_id = res.id
          item.recommended = res.recommended
          this.storeFront.product_item_count += 1
          return res
        })
        .catch(e => {
          if (e.status == 406){
            this.$refs.noPriceItem.message = e.data.message;
            this.noPriceItemID = e.data.item_id
            $('#no-price-item-modal').modal('show');
          }
        })
    },

    onRemoveItemToRecommend(item) {
      var storeProfileItemId = null
      if(!!item.store_profile_item_id){
        storeProfileItemId = item.store_profile_item_id;
      }else if(!!item.id){
        storeProfileItemId = item.id
      }
      const bodyRequest = {
        recommended: false
      }
      this.$api
        .patchAPI({
          _action: `/storefront/items/${storeProfileItemId}`,
          _body: bodyRequest
        })
        .then(res => {
          item.recommended = res.recommended
          this.getStoreRecommendItems()
          this.onGetStoreItems()
        })
        .catch(e => {
        })
    },

    onAddItemToRecommend(item) {
      if(!item.recommended && this.recommendedItems.length > 9){
        $('#recommend-item-alert').modal('show')
        return
      }

      if(!item.store_profile_item_id){
        // Auto add product then update to recommend
        // this.onAddItemToStoreFront(item)
        const bodyRequest = {
        item_id: item.item.id,
        store_profile: this.storeFront.id,
        recommended: true,
        }
        if (item.item_variant_combination) bodyRequest.item_variant_combination_id = item.item_variant_combination.id
        this.$api
          .postAPI({
            _action: '/storefront/items',
            _body: bodyRequest
          })
          .then(res => {
            item.store_profile_item_id = res.id
            item.recommended = res.recommended
            this.storeFront.product_item_count += 1
            this.getStoreRecommendItems()
          })
          .catch(e => {
            if (e.status == 406){
              this.$refs.noPriceItem.message = e.data.message;
              this.noPriceItemID = e.data.item_id
              $('#no-price-item-modal').modal('show');
            }
          })
      }else {
        var storeProfileItemId = null
        if (!!item.store_profile_item_id) {
          storeProfileItemId = item.store_profile_item_id;
        } else {
          storeProfileItemId = item.id
        }
        const bodyRequest = {
          recommended: !item.recommended
        }
        this.$api
            .patchAPI({
              _action: `/storefront/items/${storeProfileItemId}`,
              _body: bodyRequest
            })
            .then(res => {
              item.recommended = res.recommended
              this.getStoreRecommendItems()
            })
            .catch(e => {
            })
      }
    },

    onRemoveItemOutOfStorefront(item) {
      if (this.storeFront.product_item_count === 1 && !this.forceUpdateAsProductEmpty) {
        $('#product-before-remove-last-item-preview-modal').modal('show')
        this.productCatalogTarget = item
        this.forceUpdateAsProductEmpty = true
        return
      }

      this.$api
        .deleteAPI({ _action: `/storefront/items/${item.store_profile_item_id}` })
        .then(res => {
          item.store_profile_item_id = null
          item.recommended = false
          this.storeFront.product_item_count -= 1
          this.getStoreRecommendItems()
          return res
         })
        .catch(e => { throw e })
        .finally(() => {
          this.$refs.productBeforeRemoveLastItemPreviewModal.close()
          this.forceUpdateAsProductEmpty = false
          this.productCatalogTarget = null
        })
    },

    // ========================= Storefront Promotion Items ====================== //
    clickAddNewPromo() {
      this.dummyPromos.uuid = this.uuidv4()
      const newPormo = JSON.parse(JSON.stringify(this.dummyPromos))
      newPormo.priority = this.promos.length
      this.promos.push(newPormo)
      this.$emit('needConfirm', true)
    },

    gotoEditItem() {
      this.$refs.noPriceItem.close();
      if(!!this.noPriceItemID){
        window.location.href = `${window.location.origin}/edit-item/${this.noPriceItemID}`
      }
    },

    onAddPromotion(promoItem, index) {
      let that = this
      const { title, url, enable, priority } = promoItem
      const bodyRequest = { title, url, enable, store_profile: this.storeFront.id, priority }

      return this.$api
        .postAPI({
          _action: '/storefront/promo',
          _body: bodyRequest
        })
        .then(res => {
          // update promotion data
          that.promos[index] = res
          return res
        })
        .catch(e => { throw e })
    },

    onEditPromotion(promoItem, index) {
      let that = this
      const { title, url, enable, store_profile_id, priority } = promoItem
      const bodyRequest = { title, url, enable, store_profile_id, priority }

      return this.$api
        .patchAPI({
          _action: `/storefront/promo/${promoItem.id}`,
          _body: bodyRequest
        })
        .then(res => {
          that.promos[index] = res
          return res
        })
        .catch(e => { throw e })
    },

    onRemovePromo(promo, index) {
      let that = this
      if (promo.id) {
        this.$api
          .deleteAPI({ _action: `/storefront/promo/${promo.id}` })
          .then(res => {
            that.promos.splice(index, 1)
            // remove same position on promosRawData
            that.promosRawData.splice(index, 1)
            return res
          })
          .catch(e => { throw e })
      } else {
        that.promos.splice(index, 1)
      }
    },

    async addOrUpdatePromotions() {
      if (!this.promos.length
        || !this.storeFront
        || !this.storeFront.id
        || JSON.stringify(this.promos) === JSON.stringify(this.promosRawData)) return

      for (let i = 0; i < this.promos.length; i++) {
        this.promos[i].id
          ? await this.onEditPromotion(this.promos[i], i)
          : await this.onAddPromotion(this.promos[i], i)
      }

      // keep raw promos to compare later
      this.promosRawData = JSON.parse(JSON.stringify(this.promos))
      this.$emit('needConfirm', false)
    },

    uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },

    changePromotionLinkPosition() {
      for (let i = 0; i < this.promos.length; i++) {
        this.promos[i].priority = i
      }
    },
    changeRecommendItemPosition(change) {
      let bodyParam = []
      this.recommendedItems.forEach(function(item, index){
        item.priority = index;
        bodyParam.push({'id': item.id, 'priority': index})
      });
      this.$api
        .postAPI({
          _action: `/storefront/items/priority`,
          _body: bodyParam
        })
        .then(res => {
        })
        .catch(e => {
        })
    },

    // ========================= Support ====================== //
    async setupStoreFrontRelatedData() {
      this.getStoreRecommendItems()
      // get store product items
      await this.onGetStoreItems()
      if (this.storeFront && this.storeFront.id) {
        // keep raw promos to compare later
        this.promosRawData = JSON.parse(JSON.stringify(this.promos))
      }
      // replace image uploader
      $('#storefront-image').attr('src', this.storeFront.resized_image_representation)
    },

    resetLocalState() {
      this.storeFront = null,
      this.storefrontImage = null,
      this.params = {
        storefront_status: false,
        sobat_catalog_price: null,
        age_restriction: null,
        sobat_catalog_description: null,
        sobat: false,
        phone_number: '',
        slug: '',
        delivery_information: '',
        working_hours_information: '',
        payment_information: '',
        other_note: '',
        force_disable_delivery_option: null
      },
      this.promos = [],
      this.items = {
        page: 1,
        searchKey: '',
        perPage: 10,
        data: null
      },
      this.dummyPromos = {
        uuid: '',
        title: '',
        url: '',
        enable: true,
        priority: 0
      },
      this.isSlugAvailable = true
      this.forceUpdateAsProductEmpty = false
    },

    onCheckSlugAvailable() {
      if (!this.params.slug) return
      const that = this
      clearTimeout(this.debounce)

      this.debounce = setTimeout(() => {
        that.$api
          .getAPI({ _action: `/storefront/profile?slug=${that.params.slug}` })
          .then(res => {
            that.isSlugAvailable = !res.results.length
            return res
          })
          .catch(e => { throw e })
      }, 1000)
    },

    onChangeLanguageByQuery() {
      if (!this.queryLanguage) return
      if (this.queryLanguage.includes('en') || this.queryLanguage.toUpperCase() === 'EN') {
        return this.$lang.setLang('en')
      }

      if (this.queryLanguage.includes('id') || this.queryLanguage.toUpperCase() === 'ID') {
        return this.$lang.setLang('id')
      }
    }
  },

  async created() {
    this.$validator.extend('notStartWithZero', {
      validate: (value) => {
        if (!value.startsWith('0', 0)) return true
        return false
      }
    })


    // get language query
    this.onChangeLanguageByQuery()

    // check if setting on mobile web view
    if (this.mobileSetting && this.queryStoreId) {
      this.storeId = this.queryStoreId
      await this.createOrGetStorefront()
    } else {
      const stores = await this.getStores()
      if(this.d2c_type !== 0){
        await this.getSobatCategories();
      }
      this.storeId = this.stores[0].id
      await this.createOrGetStorefront()
    }

    // get data relative storefront
    this.getStoreRecommendItems()
    await this.setupStoreFrontRelatedData()

  },

  watch: {
    params: {
      handler(value) {
        if (JSON.stringify(this.getStorefrontProfileInit()) !== JSON.stringify(this.getStorefrontParamsRequest())) {
          this.$emit('needConfirm', true)
        } else {
          this.$emit('needConfirm', false)
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
  .card {
    border: 1px solid #636470;
    background-color: #fff;
    border-radius: 5px;
    padding-left: 20px;
  }

  .card-tagger {
    position: absolute;
    width: 20px;
    height: 100%;
    background-color: #F2EDFD;
    left: 0;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  .card-tagger {
    cursor: grab;
  }

  .card-tagger span {
    position: absolute;
    top: 50%;
    left: 8px;
    transform: translateY(-50%) rotate(90deg);
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
  }

  .card .card-footer {
    background: transparent;
    padding-left: 8px;
  }

  .card .card-title {
    color: #3F424F;
    margin-bottom: 8px;
    text-align: left;
  }

  .form-control.is-valid {
    border-color: #28b779;
  }

  .form-inline {
    flex-wrap: nowrap;

    label {
      margin-bottom: 0;
    }
  }

  .upload-img-merge-btn {
    width: 100%;
    position: relative;

    .btn.upload-img {
      width: 100%;
    }
  }

  .mobile-setting {
    margin: -24px -32px;
    padding: 16px;
    background: #fff;

    .btn {
      text-transform: capitalize;
    }

    .btn-primary {
      &:hover,
      &:focus,
      &:active {
        background-color: #412386 !important;
        border: #412386 !important;
      }
    }

    .font-20 {
      font-size: 16px;
    }

    .switch {
      label {
        &:before {
          width: 42px;
          height: 24px;
        }

        &:after {
          width: 22px;
          height: 22px;
          background-color: #fff !important;
          top: 1px;
          left: -1px;
        }
      }

      input:checked {
        + label {
          &:before {
            background-color: #412386;
          }

          &:after {
            background-color: #fff;
            left: -10px;
          }
        }
      }
    }

    .upload-img-merge-btn {
      color: #412386;
      background-color: #fff;
      margin-top: 8px;
      width: auto;
    }

    .card {
      .card-body {
        padding: 8px 12px;
      }

      .card-footer {
        padding: 0;
      }
    }

    .list-group-item {
      padding-left: 0;
      padding-right: 0;
      border-left: 0;
      border-right: 0;

      &:first-child {
        border-top: 0;
      }

      &:last-child {
        border-bottom: 0;
      }

      .btn {
        font-weight: 600;
        text-transform: uppercase;
        color: #412386;
      }

      p {
        margin-bottom: 0;
      }
    }
  }
  #table-product-catalog > tbody > tr > td,
  #table-product-catalog > thead > tr > td,
  #table-product-catalog {
    border-left: 0;
    border-right: 0;
  }
  #table-product-catalog > tbody > tr > td > button{
    font-weight: 600;
    text-transform: uppercase;
    color: #412386;
    margin-top: 0;
    margin-bottom: 0;
  }
  #table-product-catalog > tbody > tr > td{
    vertical-align: middle;
  }

</style>
